export default __webpack_public_path__ + "static/media/amaze-4.f4d4c298.jpg";